import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { usePetPolicies } from '../../../../hooks/usePetPolicies';

import clockIcon from '../../../../assets/policy/info-circle.svg';

import { currencyFormatByLocale } from '../../../../services/utils';

import { ColumnWrapper } from './ColumnWrapper';
import { RowWrapper } from './RowWrapper';
import { CellWithTitle } from './CellWithTitle';
import { WaitingPeriodRow } from './WaitingPeriodRow';
import { CoveragePPUInfoFeeShimmer } from './CoveragePPUInfoFeeShimmer';

import styles from '../css/CoveragePPUInfoFee.module.css';
import { formatShortDateByLanguage } from '../../../../services/language.utils';
import { LANGUAGES_FR_CA } from '../../../../i18n';

const CoveragePPUInfoFee = ({
  selectedPolicy = {},
}) => {
  const { t } = useTranslation('insurance');
  const petPolicies = usePetPolicies();
  const { loading } = petPolicies;

  const formatDate = (date) => formatShortDateByLanguage(date);

  const policyLimit = useMemo(() => {
    if (selectedPolicy.PolicyDisplayNumber) {
      const benefit = selectedPolicy?.Benefit
        .replace('K', ',000')
        .replace('$', '');

      // currency format for policy not for language
      // TODO: currency should come from the backend pending
      return t('coverageOverviewPPU.limitPerTerm', {
        benefit: currencyFormatByLocale({
          locale: LANGUAGES_FR_CA,
          value: benefit,
        }),
      });
    }

    return t('coverageOverviewPPU.na');
  }, [selectedPolicy, t]);

  if (loading) {
    return <CoveragePPUInfoFeeShimmer />;
  }

  return (
    <div className={styles.mainContainer}>
      <ColumnWrapper>
        <RowWrapper>
          <CellWithTitle
            description={selectedPolicy.PolicyDisplayNumber}
            title={t('coverageOverviewPPU.policyNumber')}
          />

          <CellWithTitle
            description={selectedPolicy.Id} // TBC
            title={t('coverageOverviewPPU.memberId')}
          />
        </RowWrapper>

        <RowWrapper>
          <CellWithTitle
            description={selectedPolicy.ProductName} // TBC
            title={t('coverageOverviewPPU.policyName')}
          />

          <CellWithTitle
            description={policyLimit} // TBC
            title={t('coverageOverviewPPU.policyLimit')}
          />

          <CellWithTitle
            description={`${formatDate(selectedPolicy.PolicyStartDate)} - 
              ${formatDate(selectedPolicy.PolicyEndDate)}`}
            title={t('coverageOverviewPPU.policyTerm')}
          />
        </RowWrapper>
      </ColumnWrapper>

      <div className={styles.waitingPeriodContainer}>
        <div className={styles.waitingPeriodsTitleContainer}>
          <h1>{t('coverageOverviewPPU.waitingPeriod')}</h1>

          <img alt="" src={clockIcon} />
        </div>

        <WaitingPeriodRow
          description="48 hours" // backend not ready yet...
          title={t('coverageOverviewPPU.accidentBenefits')}
        />

        <WaitingPeriodRow
          description="14 days" // backend not ready yet...
          title={t('coverageOverviewPPU.illnessBenefits')}
        />

        <WaitingPeriodRow
          description="48 hours" // backend not ready yet...
          title={t('coverageOverviewPPU.additionalBenefits')}
        />
      </div>
    </div>
  );
};

export { CoveragePPUInfoFee };
